const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Quizzes Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Partners', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/learn/v3/partners/:subresource', null, {
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    getOne: {params: {subresource: ''}, method: 'GET', isArray: false},
  });
  
}]);
